export default __webpack_public_path__ + "static/media/icn_back.b4da6659.svg";